export default __webpack_public_path__ + "static/media/betslipEmpty.841dd4f7.png";